import React, { useState, useRef, useEffect } from 'react'
import { BetButton, BetButtonsWrapper } from './BetButtonsStyles'
import { BET_BUTTONS_PROPS } from './interface'
import { colors } from 'lib/colors'
import { BetButtonText } from './BetButtonText'
import handleRightActions from './helpers/rightButtonActions'
import handleLeftActions from './helpers/leftButtonActions'
import HandleClickable from './helpers/useClickable'
import { useButtonSounds } from './betButtonSounds'
// import { settings, useSettings } from '../../../settings/useSettings'

export default function BetButtons({
  audio,
  stake,
  ante,
  AAbonus,
  currency,
  active,
  gameState,
  handleUndo,
  handleDeal,
  handleRaise,
  handleFold,
  handleNewBet,
  handleDealOut,
  handleActive,
  handleClearCards,
  handleShowResult,
  clearStake,
  handleIsFolded,
  isError,
}: BET_BUTTONS_PROPS) {
  const { DEAL, UNDO } = BetButtonText(ante, AAbonus, currency, 2, gameState)
  const color = gameState === 0 ? colors.secondary : colors.quaternary
  const [isClickable, setIsClickable] = useState<boolean>(false)

  HandleClickable(gameState, isError, setIsClickable)
  const undoDisabled =
    gameState === 0 &&
    ((active === 'ante' && ante === '0') ||
      (active === 'bonus' && AAbonus === 'AA'))

  const timer = useRef<any>()
  const [buttonPressMoment, setbuttonPressMoment] = useState<number | null>(0)

  useEffect(() => {
    if (gameState === 0 && buttonPressMoment) {
      timer.current = setTimeout(() => {
        clearStake()
        audio?.sound && sfxs.playClearSFX()
      }, 500)
    }
  }, [buttonPressMoment])

  const handleButtonPressMoment = () => {
    setbuttonPressMoment(Date.now())
  }

  const handleLongPress = () => {
    clearTimeout(timer.current)
    setbuttonPressMoment(null)
  }
  const sfxs = useButtonSounds(audio)

  return (
    <BetButtonsWrapper>
      <BetButton
        gameState={gameState}
        isDisabled={undoDisabled || isClickable}
        onClick={() =>
          handleLeftActions(
            audio,
            gameState,
            handleUndo,
            handleFold,
            handleDealOut,
            handleNewBet,
            setIsClickable,
            handleActive,
            sfxs.playUndoSFX,
            sfxs.playFoldlSFX,
            sfxs.playnewBetSFX,
            handleClearCards,
            handleIsFolded,
          )
        }
        onMouseDown={handleButtonPressMoment}
        onMouseUp={handleLongPress}
        onTouchStart={handleButtonPressMoment}
        onTouchEnd={handleLongPress}
        background={colors.primaryDark}
        color={color}
      >
        <div className='btn'>{UNDO}</div>
        <div className='white' />
      </BetButton>
      <BetButton
        raise
        isDisabled={(gameState === 0 && ante === '0') || isClickable}
        onClick={() =>
          handleRightActions(
            audio,
            ante,
            AAbonus,
            gameState,
            handleRaise,
            handleDeal,
            handleDealOut,
            setIsClickable,
            handleActive,
            sfxs.playDealSFX,
            sfxs.playRaiseSFX,
            sfxs.playRebetSFX,
            handleClearCards,
            handleShowResult,
          )
        }
      >
        <div className='btn'>{DEAL}</div>
        <div className='white' />
      </BetButton>
    </BetButtonsWrapper>
  )
}
